import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-blue-900 text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-green-400 rounded-xl flex items-center justify-center">
                <i className="ri-wifi-line text-2xl text-white"></i>
              </div>
              <span className="text-2xl font-bold">WiFi Portal</span>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              {t('footerDescription')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">{t('quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="/#packages-section" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-left-s-line"></i>
                  {t('packages')}
                </a>
              </li>
              <li>
                <a href="/#payment-section" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-left-s-line"></i>
                  {t('payment')}
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-left-s-line"></i>
                  {t('aboutUs')}
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-left-s-line"></i>
                  {t('contactUs')}
                </a>
              </li>
              <li>
                <a href="/captive-portal" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-left-s-line"></i>
                  بوابة الدخول
                </a>
              </li>
            </ul>
          </div>

          {/* Payment Methods */}
          <div>
            <h3 className="text-xl font-bold mb-6">{t('paymentMethods')}</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-gray-300">
                <i className="ri-smartphone-line text-xl text-orange-400"></i>
                <span>Orange Money</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <i className="ri-phone-line text-xl text-blue-400"></i>
                <span>Moov Money</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <i className="ri-mobile-download-line text-xl text-yellow-400"></i>
                <span>MTN Mobile Money</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <i className="ri-wallet-3-line text-xl text-purple-400"></i>
                <span>Wave</span>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">{t('contactInfo')}</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3 text-gray-300">
                <i className="ri-map-pin-line text-xl text-green-400 flex-shrink-0"></i>
                <span>{t('address')}</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <i className="ri-phone-line text-xl text-blue-400"></i>
                <span dir="ltr">+223 XX XX XX XX</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <i className="ri-mail-line text-xl text-purple-400"></i>
                <span dir="ltr">info@wifiportal.com</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <i className="ri-dashboard-line text-xl text-orange-400"></i>
                <a href="/admin" className="hover:text-white transition-colors cursor-pointer">
                  لوحة التحكم
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-center md:text-right">
            © 2024 WiFi Portal. {t('allRightsReserved')}
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
